/**
 * Resolves a raw form file value to a downloadable Blob/File, or null if the
 * value does not represent a local file that can be downloaded.
 */
export const getDownloadableFile = (fileValue) => {
  if (!fileValue) return null;

  // Arrays (V2FileUpload stores uploads as an array)
  const resolved = Array.isArray(fileValue) ? fileValue[0] || null : fileValue;
  if (!resolved) return null;

  if (resolved instanceof Blob) return resolved;
  if (resolved.file instanceof Blob) return resolved.file;

  return null;
};

/**
 * Triggers a browser file download for the provided raw form file value.
 */
export const downloadFile = (fileValue) => {
  const downloadableFile = getDownloadableFile(fileValue);
  if (!downloadableFile) return;

  const objectUrl = window.URL.createObjectURL(downloadableFile);
  const anchor = document.createElement('a');

  anchor.href = objectUrl;
  anchor.download = downloadableFile.name || 'download';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(objectUrl);
};
